import React, { useState } from 'react';
import { Heart, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-38">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-39">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-white text-artisanal-brown rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-40">
            <div className="flex items-center justify-between px-6 py-4 border-b border-artisanal-beige" data-id="element-41">
              <h3 className="font-serif text-xl font-bold" data-id="element-42">{title}</h3>
              <button onClick={onClose} className="p-1 rounded-full hover:bg-artisanal-beige transition-colors" data-id="element-43">
                <X className="w-5 h-5" data-id="element-44" />
              </button>
            </div>
            <div className="px-6 py-6 overflow-y-auto max-h-[65vh] font-sans text-sm leading-relaxed text-artisanal-brown/80 space-y-4" data-id="element-45">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function FooterSection() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-artisanal-brown text-artisanal-cream py-12" data-id="element-46">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-47">
          <h3 className="font-serif text-2xl md:text-3xl mb-6 font-bold" data-id="element-48">
            El momento perfecto para empezar a crear es hoy.
          </h3>
          <p className="font-sans text-artisanal-beige/80 max-w-2xl mx-auto mb-8" data-id="element-49">
            Date la oportunidad de descubrir una pasión que no solo embellecerá
            tu hogar, sino que transformará tu forma de ver lo hecho a mano.
          </p>

          <button className="bg-artisanal-cream text-artisanal-brown font-sans font-bold text-lg px-8 py-4 rounded-full shadow-lg hover:bg-white transition-colors mb-16" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-50">
            Sí, quiero unirme al programa
          </button>

          <div className="border-t border-artisanal-beige/20 pt-8" data-id="element-51">
            <div className="flex flex-col md:flex-row justify-between items-center text-sm text-artisanal-beige/60 font-sans" data-id="element-52">
              <p data-id="element-53">
                © {new Date().getFullYear()} Velas y Jabones Artesanales. Todos
                los derechos reservados.
              </p>
              <div className="flex items-center gap-4 mt-4 md:mt-0" data-id="element-54">
                <button onClick={() => setShowPrivacy(true)} className="hover:text-artisanal-cream underline underline-offset-2 transition-colors" data-id="element-55">
                  Política de Privacidad
                </button>
                <span className="opacity-40" data-id="element-56">|</span>
                <button onClick={() => setShowTerms(true)} className="hover:text-artisanal-cream underline underline-offset-2 transition-colors" data-id="element-57">
                  Términos y Condiciones
                </button>
              </div>
            </div>
            <p className="flex items-center justify-center mt-6 text-sm text-artisanal-beige/60 font-sans" data-id="element-58">
              Hecho con{' '}
              <Heart className="w-4 h-4 mx-1 text-artisanal-terracotta" data-id="element-59" /> para
              mentes creativas
            </p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-60">
        <p data-id="element-61">
          <strong data-id="element-62">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-63">
          En Velas y Jabones Artesanales, valoramos y respetamos tu privacidad.
          Esta política describe cómo recopilamos, usamos y protegemos tu
          información personal cuando utilizas nuestro sitio web y adquieres
          nuestros productos digitales.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-64">
          1. Información que recopilamos
        </h4>
        <p data-id="element-65">
          Recopilamos la información que nos proporcionas directamente al
          realizar una compra, como tu nombre, dirección de correo electrónico y
          datos de pago. Los datos de pago son procesados de forma segura por
          nuestro proveedor de pagos y no almacenamos información de tarjetas de
          crédito.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-66">
          2. Uso de la información
        </h4>
        <p data-id="element-67">Utilizamos tu información para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-68">
          <li data-id="element-69">Procesar y entregar tu compra</li>
          <li data-id="element-70">Enviarte actualizaciones relacionadas con el curso</li>
          <li data-id="element-71">Mejorar nuestros productos y servicios</li>
          <li data-id="element-72">
            Comunicarnos contigo sobre ofertas relevantes (solo si das tu
            consentimiento)
          </li>
        </ul>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-73">
          3. Protección de datos
        </h4>
        <p data-id="element-74">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-75">
          4. Cookies
        </h4>
        <p data-id="element-76">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico del sitio. Puedes configurar tu
          navegador para rechazar cookies en cualquier momento.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-77">
          5. Tus derechos
        </h4>
        <p data-id="element-78">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. Para ejercer estos derechos, puedes
          contactarnos a través de los canales disponibles en nuestro sitio.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-79">
          6. Cambios en esta política
        </h4>
        <p data-id="element-80">
          Nos reservamos el derecho de actualizar esta política de privacidad.
          Cualquier cambio será publicado en esta página con la fecha de
          actualización correspondiente.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-81">
        <p data-id="element-82">
          <strong data-id="element-83">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-84">
          Al acceder y utilizar este sitio web y adquirir nuestros productos
          digitales, aceptas los siguientes términos y condiciones. Por favor,
          léelos cuidadosamente antes de realizar tu compra.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-85">
          1. Productos digitales
        </h4>
        <p data-id="element-86">
          Nuestros cursos y guías son productos digitales de acceso inmediato.
          Una vez realizada la compra, recibirás acceso al contenido a través de
          la plataforma indicada.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-87">
          2. Política de reembolso
        </h4>
        <p data-id="element-88">
          Debido a la naturaleza digital de nuestros productos, no ofrecemos
          reembolsos una vez que se ha otorgado el acceso al contenido. Te
          invitamos a revisar toda la información disponible antes de realizar
          tu compra.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-89">
          3. Propiedad intelectual
        </h4>
        <p data-id="element-90">
          Todo el contenido del curso, incluyendo videos, guías, recetas,
          fórmulas y materiales descargables, es propiedad exclusiva de Velas y
          Jabones Artesanales. Queda prohibida su reproducción, distribución o
          reventa sin autorización expresa.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-91">
          4. Uso del contenido
        </h4>
        <p data-id="element-92">
          El acceso al curso es personal e intransferible. Puedes utilizar los
          conocimientos adquiridos para crear y vender tus propios productos
          artesanales, pero no puedes compartir, copiar o redistribuir el
          material del curso.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-93">
          5. Resultados
        </h4>
        <p data-id="element-94">
          Los resultados pueden variar según la dedicación, práctica y esfuerzo
          de cada persona. No garantizamos resultados específicos de ingresos o
          ventas.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-95">
          6. Modificaciones
        </h4>
        <p data-id="element-96">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor desde su publicación en esta
          página.
        </p>
        <h4 className="font-serif font-bold text-base text-artisanal-brown mt-4" data-id="element-97">
          7. Aceptación
        </h4>
        <p data-id="element-98">
          Al realizar tu compra, confirmas que has leído, entendido y aceptado
          estos términos y condiciones en su totalidad.
        </p>
      </LegalModal>
    </>;
}